exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-start[data-v-2274da60]{padding:32px 16px;text-align:center;background:#f7faf9;border:1px solid #e2e7ec;border-radius:8px}.chat-start p[data-v-2274da60]{color:#6b7280;font-size:14px}.chat-start button[data-v-2274da60]{background:#279a7b;color:#fff;border-radius:6px;padding:10px 18px;font-weight:600}.onboarding-chat-frame[data-v-2274da60]{display:block;width:100%;height:600px;border:0;background:#fff}", ""]);

// exports
